module.exports = __webpack_public_path__ + "img/yg02-01.03c87ccd.png";